import Nbio from './Nbio.component';

export default Nbio;
